export const ADMIN_ROUTE = '/admin'
export const PROFILE_ROUTE = '/profile'
export const ALBUM_ROUTE = '/album'
export const MAIN_ROUTE = '/'
export const ABOUT_ROUTE = '/about'
export const PREMIUM_ROUTE = '/premium'
export const API_ROUTE = '/api'

export const CLIENT_URL = 'https://uimage.onrender.com/'
export const API_URL = 'https://uimage-server.onrender.com/'

//https://uimage-server.onrender.com/
//http://localhost:5000/